const APA_CITATION_LIBRARY_KEY = 'boppps_saved_apa_citations';
const APA_CITATION_LIBRARY_GLOBAL_KEY = '__bopppsSavedApaCitations';
const APA_CITATION_LIBRARY_EVENT = 'apa-citation-library-updated';

const cloneSavedCitations = (citations) => JSON.parse(JSON.stringify(citations || []));

export const readSavedApaCitations = () => {
  if (typeof window === 'undefined') return [];
  try {
    const globalCitations = window[APA_CITATION_LIBRARY_GLOBAL_KEY];
    if (Array.isArray(globalCitations)) {
      return cloneSavedCitations(globalCitations);
    }
    const raw = window.localStorage.getItem(APA_CITATION_LIBRARY_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch (error) {
    console.warn('[ApaLibrary] Unable to read saved APA citations', error);
    return [];
  }
};

export const writeSavedApaCitations = (citations) => {
  if (typeof window === 'undefined') return;
  try {
    if (!citations || citations.length === 0) {
      delete window[APA_CITATION_LIBRARY_GLOBAL_KEY];
      window.localStorage.removeItem(APA_CITATION_LIBRARY_KEY);
    } else {
      window[APA_CITATION_LIBRARY_GLOBAL_KEY] = cloneSavedCitations(citations);
      window.localStorage.setItem(APA_CITATION_LIBRARY_KEY, JSON.stringify(citations));
    }
    window.dispatchEvent(new CustomEvent(APA_CITATION_LIBRARY_EVENT));
  } catch (error) {
    console.warn('[ApaLibrary] Unable to write saved APA citations', error);
  }
};

export const subscribeToApaLibraryUpdates = (callback) => {
  if (typeof window === 'undefined') return () => {};
  const handler = () => callback(readSavedApaCitations());
  window.addEventListener(APA_CITATION_LIBRARY_EVENT, handler);
  return () => window.removeEventListener(APA_CITATION_LIBRARY_EVENT, handler);
};

export const APA_CITATION_LIBRARY_KEYS = {
  key: APA_CITATION_LIBRARY_KEY,
  globalKey: APA_CITATION_LIBRARY_GLOBAL_KEY
};
